import { Component } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'demo-shell',
    templateUrl: './demo-shell.html',
    styleUrls: ['./demo-shell.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoShellComponent {
    routes = [
        { path: 'application-shell', label: 'Application Shell' },
        { path: 'layout', label: 'Layout' },
        { path: 'grid', label: 'Grid' },
        { path: 'form-controls', label: 'Form Controls' },
        { path: 'select', label: 'Select' },
        { path: 'media', label: 'Media' },
        { path: 'navigation', label: 'Navigation' },
        { path: 'form-layout', label: 'Form Layout' },
        { path: 'upp-panel', label: 'Widget: Panel' },
        { path: 'upp-dialog', label: 'Widget: Dialog' },
        { path: 'upp-header', label: 'Widget: Header' },
        { path: 'upp-application', label: 'Widget: Application' },
        { path: 'upp-dropdown', label: 'Widget: Dropdown' },
        { path: 'konva', label: 'upp-konva' },
    ];
}
